export enum EMotifPrelevement {
    Routine = 1,
    RoutineSortieESET = 2,
    AppareilNeuf = 3,
    AppareilDePret = 4,
    Recontrole = 5,
    RetourDeReparation = 6,
    QPESET = 7,
    QPLDE = 8,
}